export const CALL_INTEL_PMS_WRITEBACK_FF = 'call-intelligence:pms-writeback';
export const CALL_INTEL_TASK_SETTINGS_FF = 'call-intel:task-settings';

export const AI_OFFICE_USER_UUID = '00000000-0000-0000-0000-000000000000';

export enum CIBannerPriorityGroupEnum {
  OVERVIEW_PAGE = 'call-intel-overview-page-banners',
  CALL_INSIGHTS_PANEL = 'call-intel-call-insights-panel-banners',
}

export enum CIBannerEnum {
  TSS_OVERVIEW_BANNER = 'tss-overview-banner',
  TSS_CALL_INSIGHTS = 'tss-call-insights-banner',
  PMS_WRITEBACK_CALL_INSIGHTS = 'pms-writeback-call-insights-banner',
}

export const CIBannerPriorityList: Partial<Record<CIBannerPriorityGroupEnum, CIBannerEnum[]>> = {
  [CIBannerPriorityGroupEnum.OVERVIEW_PAGE]: [CIBannerEnum.TSS_OVERVIEW_BANNER],
  [CIBannerPriorityGroupEnum.CALL_INSIGHTS_PANEL]: [
    CIBannerEnum.PMS_WRITEBACK_CALL_INSIGHTS,
    CIBannerEnum.TSS_CALL_INSIGHTS,
  ],
};
